import { ReactNode } from "react"
import ReactModal from "react-modal"

type Props = {
  isOpen: boolean
  children: ReactNode
  onRequestClose: () => void
}

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, .35)",
    zIndex: 101,
  },
  content: {
    background: "none",
    border: "none",
    borderRadius: "10px",
    bottom: "auto",
    left: "50%",
    marginRight: "-50%",
    overflow: "visible",
    padding: "0",
    right: "auto",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "auto",
  },
}

const AppSimulatorModal = (props: Props) => {
  const { isOpen, children, onRequestClose } = props

  return (
    <ReactModal
      style={customStyles}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      {children}
    </ReactModal>
  )
}

export default AppSimulatorModal
